import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { formatSecondsToMinutesSeconds } from '@/utils/formatters.ts'
import useSpeechDialogStore from './speech-dialog.store.ts'

const handleKeyDown = () => {}

const ScriptForm: FC = () => {
  const { t } = useTranslation()
  const {
    scriptText,
    scriptTextError,
    setScriptText,
    scriptDuration,
    isRecording,
    countdown,
  } = useSpeechDialogStore()
  const animateRecording = isRecording || countdown !== undefined
  return (
    <div
      className={`relative flex min-w-[200px] max-w-[380px] flex-1 flex-col gap-[32px] p-5 transition-all duration-300 ease-in-out ${animateRecording ? 'border-none bg-black' : 'border-r border-zinc-700 bg-transparent'}`}
    >
      <div
        className={`absolute inset-0 p-5 transition-all duration-500 ease-in-out ${animateRecording ? 'pointer-events-none opacity-0' : 'scale-100 opacity-100'} flex flex-col gap-[12px]`}
      >
        <div className="inline-flex flex-row items-center justify-between gap-[10px]">
          <div className="flex flex-row items-center gap-[10px]">
            <span>{t('ls_new_script_text')}</span>
            <span className="inline-flex h-[28px] items-center gap-[8px] rounded-[300px] bg-white/10 px-[8px] py-[6px] text-[12px] font-semibold">
              {formatSecondsToMinutesSeconds(scriptDuration)}
            </span>
          </div>
          <div className="flex flex-row items-center">
            {scriptTextError && (
              <div className="text-xs font-normal leading-none text-red-500">
                {t(scriptTextError)}
              </div>
            )}
          </div>
        </div>
        <textarea
          className={`sizing-box h-[44px] min-h-[300px] w-full rounded-[8px] border bg-transparent px-[12px] py-[16px] shadow-[0px_0px_12px_0px_#0000000A] transition-all duration-300 ease-in-out ${scriptTextError ? 'border-red-500 placeholder:text-red-500' : 'border-zinc-600 placeholder:text-zinc-400'}`}
          placeholder={t('ls_new_script_text')}
          value={scriptText}
          onChange={({ currentTarget: { value } }) => setScriptText(value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      {/* Recording State */}
      <div
        className={`absolute flex h-[90%] w-[90%] flex-col items-start overflow-y-auto transition-all duration-500 ease-in-out ${animateRecording ? 'left-5 scale-100 opacity-100' : 'pointer-events-none left-7 scale-[97%] opacity-0'}`}
      >
        <p className="whitespace-pre-line text-lg font-medium text-white transition-all duration-500">
          {scriptText}
        </p>
      </div>
    </div>
  )
}

export default ScriptForm
